import './tags.less'

import {m, wrap} from '@codeurs/front'
import {Fragment, useEffect, useState} from 'react'
import {StringParam} from 'use-query-params'
import {Newsletter} from 'views/partials/newsletter'
import {useList} from '../../hooks/uselist'
import {CardData, PageData, PaginationResult} from '../../types'
import {useFilter} from '../../util/params'
import {style} from '../../util/style'
import {Layout} from '../layout'
import {ArticleCard, ArticleGrid} from '../partials/articlegrid'
import {HeaderPortal} from '../partials/header'
import {Hero} from '../partials/hero'
import {LoadMore} from '../partials/loadmore'
import {Theme} from '../theme'

const styles = style('tags', ['isloading'])

export const Tags = wrap(Layout)((props: {
  data: PageData & {
    results: PaginationResult<CardData>
  }
  location: Location
}) => {
  const {url, results, hero, tagslist, tagspath, title, newsletter, language} =
    props.data

  const filter = useFilter({
    tag: StringParam
  })

  const list = useList<CardData>({
    url: url + filter.toString(),
    data: {json: 'results'},
    hydrate: results,
    amounts: {
      start: 10,
      page: 12
    }
  })
  const getTagName = () => {
    const tagItem = tagslist.find(tag => tag.slug === filter.get('tag'))
    if (!tagItem) return filter.get('tag')
    return tagItem.tag
  }

  const [tagName, setTagname] = useState(getTagName())
  const {location} = props
  useEffect(() => {
    if (location.search) {
      window.scrollTo(0, 0)
      setTagname(getTagName())
    }
  }, [location.search])

  return (
    <Fragment>
      <div class={styles}>
        <Theme.Container>
          <HeaderPortal>
            <Hero small={false} hero={!!(hero && hero.image)}>
              <Theme.H1>
                {title}: {tagName} ({results.total})
              </Theme.H1>
            </Hero>
          </HeaderPortal>
        </Theme.Container>
        <ArticleGrid hasMore={list.hasMore}>
          {list.items.map((item, i) => {
            if (!item) return null
            return (
              <ArticleCard
                item={{key: i, ...item}}
                tagspath={tagspath}
                tagslist={tagslist}
              />
            )
          })}
        </ArticleGrid>
        {list.hasMore && (
          <div className={styles('button')}>
            <LoadMore loading={list.loading} loadMore={() => list.loadMore()} />
          </div>
        )}
      </div>
      <Newsletter {...newsletter} language={language} />
    </Fragment>
  )
})
